export default "__VITE_ASSET__S2Q5VX31__"